export interface DeclinedStripeCode {
    code: string;
    message: string;
}

export const declinedStripeCodes: DeclinedStripeCode[] = [
    {
        code: 'card_not_supported',
        message: 'Contact your bank to check if your card supports this type of purchase',
    },
    {
        code: 'test_mode_live_card',
        message: 'Live cards are not valid in test mode',
    },
    {
        code: 'card_velocity_exceeded',
        message: 'Balance limit exceeded. Please contact your bank',
    },
    {
        code: 'currency_not_supported',
        message: 'The card does not support the specified currency',
    },
    {
        code: 'do_not_honor',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'do_not_try_again',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'authentication_required',
        message: 'The card was declined as the transaction requires authentication',
    },
    {
        code: 'approve_with_id',
        message: 'The payment cannot be authorized. Try again or contact yout bank',
    },
    {
        code: 'call_issuer',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'duplicate_transaction',
        message: 'A transaction with identical amount and credit card founded. Check to see if a recent payment already exists',
    },
    {
        code: 'expired_card',
        message: 'The card has expired.	Please use another card',
    },
    {
        code: 'fraudulent',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'generic_decline',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'incorrect_number',
        message: 'The card number is incorrect',
    },
    {
        code: 'incorrect_cvc',
        message: 'The CVC number is incorrect',
    },
    {
        code: 'incorrect_pin',
        message: 'The PIN entered is incorrect',
    },
    {
        code: 'incorrect_zip',
        message: 'The ZIP/postal code is incorrect',
    },
    {
        code: 'insufficient_funds',
        message: 'The card has insufficient funds to complete the purchase.',
    },
    {
        code: 'invalid_account',
        message: 'The card, or account the card is connected to, is invalid. Please contact your bank',
    },
    {
        code: 'invalid_amount',
        message: 'The payment amount is invalid, or exceeds the amount that is allowed. Please contact your bank',
    },
    {
        code: 'invalid_cvc',
        message: 'The CVC number is invalid',
    },
    {
        code: 'invalid_expiry_month',
        message: 'The expiration month is invalid',
    },
    {
        code: 'invalid_expiry_year',
        message: 'The expiration year is invalid',
    },
    {
        code: 'invalid_number',
        message: 'The card number is incorrect',
    },
    {
        code: 'invalid_pin',
        message: 'The PIN entered is invalid',
    },
    {
        code: 'issuer_not_available',
        message: 'The card issuer could not be reached. Try again or contact your bank',
    },
    {
        code: 'lost_card',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'merchant_blacklist',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'new_account_information_available',
        message: 'The card, or account the card is connected to, is invalid. Please contact your bank',
    },
    {
        code: 'no_action_taken',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'not_permitted',
        message: 'The payment is not permitted.	Please contact your bank',
    },
    {
        code: 'offline_pin_required',
        message: 'The card has been declined as it requires a PIN',
    },
    {
        code: 'online_or_offline_pin_required',
        message: 'The card has been declined as it requires a PIN',
    },
    {
        code: 'pickup_card',
        message: 'The card cannot be used to make this payment. Please contact your bank',
    },
    {
        code: 'pin_try_exceeded',
        message: 'The allowable number of PIN tries has been exceeded',
    },
    {
        code: 'processing_error',
        message: 'An error occurred while processing the card. Please try again later',
    },
    {
        code: 'reenter_transaction',
        message: 'The payment could not be processed by the issuer for an unknown reason. Try again or contact your bank',
    },
    {
        code: 'restricted_card',
        message: 'The card cannot be used to make this payment. Please contact your bank',
    },
    {
        code: 'revocation_of_all_authorizations',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'revocation_of_authorization',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'security_violation',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'service_not_allowed',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'stolen_card',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'stop_payment_order',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'testmode_decline',
        message: 'A Stripe test card number was used',
    },
    {
        code: 'transaction_not_allowed',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'try_again_later',
        message: 'The card has been declined for an unknown reason. Try again',
    },
    {
        code: 'withdrawal_count_limit_exceeded',
        message: 'Balance limit exceeded. Please contact your bank',
    },
];



export const stripeCodeErrors: DeclinedStripeCode[] = [
    {
        code: 'card_not_supported',
        message: 'Contact your bank to check if your card supports this type of purchase',
    },
    {
        code: 'card_velocity_exceeded',
        message: 'Balance limit exceeded. Please contact your bank',
    },
    {
        code: 'currency_not_supported',
        message: 'The card does not support the specified currency',
    },
    {
        code: 'do_not_honor',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'do_not_try_again',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'authentication_required',
        message: 'The card was declined as the transaction requires authentication',
    },
    {
        code: 'approve_with_id',
        message: 'The payment cannot be authorized. Try again or contact yout bank',
    },
    {
        code: 'call_issuer',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'duplicate_transaction',
        message: 'A transaction with identical amount and credit card founded. Check to see if a recent payment already exists',
    },
    {
        code: 'expired_card',
        message: 'The card has expired.	Please use another card',
    },
    {
        code: 'fraudulent',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'generic_decline',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'incorrect_number',
        message: 'The card number is incorrect',
    },
    {
        code: 'incorrect_cvc',
        message: 'The CVC number is incorrect',
    },
    {
        code: 'incorrect_pin',
        message: 'The PIN entered is incorrect',
    },
    {
        code: 'incorrect_zip',
        message: 'The ZIP/postal code is incorrect',
    },
    {
        code: 'insufficient_funds',
        message: 'The card has insufficient funds to complete the purchase.',
    },
    {
        code: 'invalid_account',
        message: 'The card, or account the card is connected to, is invalid. Please contact your bank',
    },
    {
        code: 'invalid_amount',
        message: 'The payment amount is invalid, or exceeds the amount that is allowed. Please contact your bank',
    },
    {
        code: 'invalid_cvc',
        message: 'The CVC number is invalid',
    },
    {
        code: 'invalid_expiry_month',
        message: 'The expiration month is invalid',
    },
    {
        code: 'invalid_expiry_year',
        message: 'The expiration year is invalid',
    },
    {
        code: 'invalid_number',
        message: 'The card number is incorrect',
    },
    {
        code: 'invalid_pin',
        message: 'The PIN entered is invalid',
    },
    {
        code: 'issuer_not_available',
        message: 'The card issuer could not be reached. Try again or contact your bank',
    },
    {
        code: 'lost_card',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'merchant_blacklist',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'new_account_information_available',
        message: 'The card, or account the card is connected to, is invalid. Please contact your bank',
    },
    {
        code: 'no_action_taken',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'not_permitted',
        message: 'The payment is not permitted.	Please contact your bank',
    },
    {
        code: 'offline_pin_required',
        message: 'The card has been declined as it requires a PIN',
    },
    {
        code: 'online_or_offline_pin_required',
        message: 'The card has been declined as it requires a PIN',
    },
    {
        code: 'pickup_card',
        message: 'The card cannot be used to make this payment. Please contact your bank',
    },
    {
        code: 'pin_try_exceeded',
        message: 'The allowable number of PIN tries has been exceeded',
    },
    {
        code: 'processing_error',
        message: 'An error occurred while processing the card. Please try again later',
    },
    {
        code: 'reenter_transaction',
        message: 'The payment could not be processed by the issuer for an unknown reason. Try again or contact your bank',
    },
    {
        code: 'restricted_card',
        message: 'The card cannot be used to make this payment. Please contact your bank',
    },
    {
        code: 'revocation_of_all_authorizations',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'revocation_of_authorization',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'security_violation',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'service_not_allowed',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'stolen_card',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'stop_payment_order',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'testmode_decline',
        message: 'A Stripe test card number was used',
    },
    {
        code: 'transaction_not_allowed',
        message: 'The card has been declined for an unknown reason. Please contact your bank',
    },
    {
        code: 'try_again_later',
        message: 'The card has been declined for an unknown reason. Try again',
    },
    {
        code: 'withdrawal_count_limit_exceeded',
        message: 'Balance limit exceeded. Please contact your bank',
    },
];


const s = [
    {
        code: 'account_country_invalid_address',
        message: 'The country of the business address provided does not match the country of the account. Businesses must be located in the same country as the account.'
    },
    {
        code: 'account_invalid',
        message: 'The account ID provided as a value for the Stripe-Account header is invalid. Check that your requests are specifying a valid account ID.'

    },
    {
        code: 'account_number_invalid',
        message: 'The bank account number provided is invalid (e.g., missing digits). Bank account information varies from country to country.We recommend creating validations in your entry forms based on the bank account formats we provide.'
    },
    {
        code: 'acss_debit_session_incomplete',
        message: 'The ACSS debit session is not ready to transition to complete status yet. Please try again the request later.'
    },
    {
        code: 'alipay_upgrade_required',
        message: 'This method for creating Alipay payments is not supported anymore. Please upgrade your integration to use Sources instead.'
    },
    {
        code: 'amount_too_large',
        message: 'The specified amount is greater than the maximum amount allowed. Use a lower amount and try again.'
    },
    {
        code: 'amount_too_small',
        message: 'The specified amount is less than the minimum amount allowed. Use a higher amount and try again.'
    },
    {
        code: 'api_key_expired',
        message: 'The API key provided has expired. Obtain your current API keys from the Dashboard and update your integration to use them.'
    },
    {
        code: 'authentication_required',
        message: 'The payment requires authentication to proceed. If your customer is off session, notify your customer to return to your application and complete the payment.If you provided the error_on_requires_action parameter, then your customer should try another card that does not require authentication.'
    },
    {
        code: 'balance_insufficient',
        message: 'The transfer or payout could not be completed because the associated account does not have a sufficient balance available.Create a new transfer or payout using an amount less than or equal to the account’s available balance.'
    },
    {
        code: 'bank_account_declined'
        , message: 'The bank account provided can not be used to charge, either because it is not verified yet or it is not supported.'
    },
    {
        code: 'bank_account_exists',
        message: 'The bank account provided already exists on the specified Customer object. If the bank account should also be attached to a different customer, include the correct customer ID when making the request again.'
    },
    {
        code: 'bank_account_unusable',
        message: 'The bank account provided cannot be used for payouts. A different bank account must be used.'
    },
    {
        code: 'bank_account_unverified',
        message: 'Your Connect platform is attempting to share an unverified bank account with a connected account.'
    },
    {
        code: 'bank_account_verification_failed',
        message: 'The bank account cannot be verified, either because the microdeposit amounts provided do not match the actual amounts, or because verification has failed too many times.'
    },
    {
        code: 'billing_invalid_mandate',
        message: 'The Subscription or Invoice attempted payment on a PaymentMethod without an active mandate.In order to create Subscription or Invoice payments with this PaymentMethod, it must be confirmed on - session with a PaymentIntent or SetupIntent first.'
    },
    {
        code: 'bitcoin_upgrade_required',
        message: 'This method for creating Bitcoin payments is not supported anymore. Please upgrade your integration to use Sources instead.'
    },
    {
        code: 'card_decline_rate_limit_exceeded',
        message: 'This card has been declined too many times. You can try to charge this card again after 24 hours.We suggest reaching out to your customer to make sure they have entered all of their information correctly and that there are no issues with their card.'
    },
    {
        code: 'card_declined',
        message: 'The card has been declined. When a card is declined, the error returned also includes the decline_code attribute with the reason why the card was declined.Refer to our decline codes documentation to learn more.'
    },
    {
        code: 'cardholder_phone_number_required',
        message: 'You must have a phone_number on file for Issuing Cardholders who will be creating EU cards.You cannot create EU cards without a phone_number on file for the cardholder.See the 3D Secure Documenation for more details.'
    },
    {
        code: 'charge_already_captured',
        message: 'The charge you’re attempting to capture has already been captured. Update the request with an uncaptured charge ID.'
    },
    {
        code: 'charge_already_refunded',
        message: 'The charge you’re attempting to refund has already been refunded. Update the request to use the ID of a charge that has not been refunded.'
    },
    {
        code: 'charge_disputed',
        message: 'The charge you’re attempting to refund has been charged back. Check the disputes documentation to learn how to respond to the dispute.'
    },
    {
        code: 'charge_exceeds_source_limit',
        message: 'This charge would cause you to exceed your rolling-window processing limit for this source type. Please retry the charge later, or contact us to request a higher processing limit.'
    },
    {
        code: 'charge_expired_for_capture'
        , message: 'The charge cannot be captured as the authorization has expired. Auth and capture charges must be captured within seven days.'
    },
    {
        code: 'charge_invalid_parameter',
        message: 'One or more provided parameters was not allowed for the given operation on the Charge. Check our API reference or the returned error message to see which values were not correct for that Charge.'
    },
    {
        code: 'clearing_code_unsupported',
        message: 'The clearing code provided is not supported.'
    },
    {
        code: 'country_code_invalid',
        message: 'The country code provided was invalid.'
    },
    {
        code: 'country_unsupported',
        message: 'Your platform attempted to create a custom account in a country that is not yet supported. Make sure that users can only sign up in countries supported by custom accounts.'
    },
    {
        code: 'coupon_expired',
        message: 'The coupon provided for a subscription or order has expired. Either create a new coupon, or use an existing one that is valid.'
    },
    {
        code: 'customer_max_payment_methods',
        message: 'The maximum number of PaymentMethods for this Customer has been reached. Either detach some PaymentMethods from this Customer or proceed with a different Customer.'
    },
    {
        code: 'customer_max_subscriptions',
        message: 'The maximum number of subscriptions for a customer has been reached. Contact us if you are receiving this error.'
    },
    {
        code: 'email_invalid',
        message: 'The email address is invalid (e.g., not properly formatted). Check that the email address is properly formatted and only includes allowed characters.'
    },
    {
        code: 'expired_card',
        message: 'The card has expired. Check the expiration date or use a different card.'
    },
    {
        code: 'idempotency_key_in_use',
        message: 'The idempotency key provided is currently being used in another request. This occurs if your integration is making duplicate requests simultaneously.'
    },
    {
        code: 'incorrect_address',
        message: 'The card’s address is incorrect. Check the card’s address or use a different card.'
    },
    {
        code: 'incorrect_cvc',
        message: 'The card’s security code is incorrect. Check the card’s security code or use a different card.'
    },
    {
        code: 'incorrect_number',
        message: 'The card number is incorrect. Check the card’s number or use a different card.'
    },
    {
        code: 'incorrect_zip',
        message: 'The card’s postal code is incorrect. Check the card’s postal code or use a different card.'
    },
    {
        code: 'instant_payouts_unsupported',
        message: 'This card is not eligible for Instant Payouts. Try a debit card from a supported bank.'
    },
    {
        code: 'intent_invalid_state',
        message: 'Intent is not in the state that is required to perform the operation.'
    },
    {
        code: 'intent_verification_method_missing',
        message: 'Intent does not have verification method specified in its PaymentMethodOptions object.'
    },
    {
        code: 'invalid_card_type',
        message: 'The card provided as an external account is not supported for payouts. Provide a non-prepaid debit card instead.'
    },
    {
        code: 'invalid_characters',
        message: 'This value provided to the field contains characters that are unsupported by the field.'
    },
    {
        code: 'invalid_charge_amount',
        message: 'The specified amount is invalid. The charge amount must be a positive integer in the smallest currency unit, and not exceed the minimum or maximum amount.'
    },
    {
        code: 'invalid_cvc',
        message: 'The card’s security code is invalid. Check the card’s security code or use a different card.'
    },
    {
        code: 'invalid_expiry_month',
        message: 'The card’s expiration month is incorrect. Check the expiration date or use a different card.'
    },
    {
        code: 'invalid_expiry_year',
        message: 'The card’s expiration year is incorrect. Check the expiration date or use a different card.'
    },
    {
        code: 'invalid_number',
        message: 'The card number is invalid. Check the card details or use a different card.'
    },
    {
        code: 'invalid_source_usage',
        message: 'The source cannot be used because it is not in the correct state (e.g., a charge request is trying to use a source with a pending, failed, or consumed source). Check the status of the source you are attempting to use.'
    },
    {
        code: 'invoice_no_customer_line_items',
        message: 'An invoice cannot be generated for the specified customer as there are no pending invoice items. Check that the correct customer is being specified or create any necessary invoice items first.'
    },
    {
        code: 'invoice_no_payment_method_types',
        message: 'An invoice cannot be finalized because there are no payment method types available to process the payment. Your invoice template settings or the invoice’s payment_settings might be restricting which payment methods are available, or you might need to activate more payment methods in the Dashboard.'
    },
    {
        code: 'invoice_no_subscription_line_items',
        message: 'An invoice cannot be generated for the specified subscription as there are no pending invoice items. Check that the correct subscription is being specified or create any necessary invoice items first.'
    },
    {
        code: 'invoice_not_editable',
        message: 'The specified invoice can no longer be edited. Instead, consider creating additional invoice items that will be applied to the next invoice. You can either manually generate the next invoice or wait for it to be automatically generated at the end of the billing cycle.'
    },
    {
        code: 'invoice_payment_intent_requires_action',
        message: 'This payment requires additional user action before it can be completed successfully. Payment can be completed using the PaymentIntent associated with the invoice. See this page for more details.'
    },
    {
        code: 'invoice_upcoming_none',
        message: 'There is no upcoming invoice on the specified customer to preview. Only customers with active subscriptions or pending invoice items have invoices that can be previewed.'
    },
    {
        code: 'livemode_mismatch',
        message: 'Test and live mode API keys, requests, and objects are only available within the mode they are in.'
    },
    {
        code: 'lock_timeout',
        message: 'This object cannot be accessed right now because another API request or Stripe process is currently accessing it. If you see this error intermittently, retry the request. If you see this error frequently and are making multiple concurrent requests to a single object, make your requests serially or at a lower rate. See the rate limit documentation for more details.'
    },
    {
        code: 'missing',
        message: 'Both a customer and source ID have been provided, but the source has not been saved to the customer. To create a charge for a customer with a specified source, you must first save the card details.'
    },
    {
        code: 'not_allowed_on_standard_account',
        message: 'Transfers and payouts on behalf of a Standard connected account are not allowed.'
    },
    {
        code: 'order_creation_failed',
        message: 'The order could not be created. Check the order details and then try again.'
    },
    {
        code: 'order_required_settings',
        message: 'The order could not be processed as it is missing required information. Check the information provided and try again.'
    },
    {
        code: 'order_status_invalid',
        message: 'The order cannot be updated because the status provided is either invalid or does not follow the order lifecycle (e.g., an order cannot transition from created to fulfilled without first transitioning to paid).'
    },
    {
        code: 'order_upstream_timeout',
        message: 'The request timed out. Try again later.'
    },
    {
        code: 'out_of_inventory',
        message: 'The SKU is out of stock. If more stock is available, update the SKU’s inventory quantity and try again.'
    },
    {
        code: 'parameter_invalid_empty',
        message: 'One or more required values were not provided. Make sure requests include all required parameters.'
    },
    {
        code: 'parameter_invalid_integer',
        message: 'One or more of the parameters requires an integer, but the values provided were a different type. Make sure that only supported values are provided for each attribute. Refer to our API documentation to look up the type of data each attribute supports.'
    },
    {
        code: 'parameter_invalid_string_blank',
        message: 'One or more values provided only included whitespace. Check the values in your request and update any that contain only whitespace.'
    },
    {
        code: 'parameter_invalid_string_empty',
        message: 'One or more required string values is empty. Make sure that string values contain at least one character.'
    },
    {
        code: 'parameter_missing',
        message: 'One or more required values are missing. Check our API documentation to see which values are required to create or modify the specified resource.'
    },
    {
        code: 'parameter_unknown',
        message: 'The request contains one or more unexpected parameters. Remove these and try again.'
    },
    {
        code: 'parameters_exclusive',
        message: 'Two or more mutually exclusive parameters were provided. Check our API documentation or the returned error message to see which values are permitted when creating or modifying the specified resource.'
    },
    {
        code: 'payment_intent_action_required',
        message: 'The provided payment method requires customer actions to complete, but error_on_requires_action was set. If you’d like to add this payment method to your integration, we recommend that you first upgrade your integration to handle actions.'
    },
    {
        code: 'payment_intent_authentication_failure',
        message: 'The provided payment method has failed authentication. Provide a new payment method to attempt to fulfill this PaymentIntent again.'
    },
    {
        code: 'payment_intent_incompatible_payment_method',
        message: 'The PaymentIntent expected a payment method with different properties than what was provided.'
    },
    {
        code: 'payment_intent_invalid_parameter',
        message: 'One or more provided parameters was not allowed for the given operation on the PaymentIntent. Check our API reference or the returned error message to see which values were not correct for that PaymentIntent.'
    },
    {
        code: 'payment_intent_mandate_invalid',
        message: 'The provided mandate is invalid and can not be used for the payment intent.'
    },
    {
        code: 'payment_intent_payment_attempt_expired',
        message: 'The latest payment attempt for the PaymentIntent has expired. Check the last_payment_error property on the PaymentIntent for more details, and provide a new payment method to attempt to fulfill this PaymentIntent again.'
    },
    {
        code: 'payment_intent_payment_attempt_failed',
        message: 'The latest payment attempt for the PaymentIntent has failed. Check the last_payment_error property on the PaymentIntent for more details, and provide a new payment method to attempt to fulfill this PaymentIntent again.'
    },
    {
        code: 'payment_intent_unexpected_state',
        message: 'The PaymentIntent’s state was incompatible with the operation you were trying to perform.'
    },
    {
        code: 'payment_method_bank_account_already_verified',
        message: 'This bank account has already been verified.'
    },
    {
        code: 'payment_method_bank_account_blocked',
        message: 'This bank account has failed verification in the past and can not be used. Contact us if you wish to attempt to use these bank account credentials.'
    },
    {
        code: 'payment_method_currency_mismatch',
        message: 'The currency specified does not match the currency for the attached payment method. A payment can only be created for the same currency as the corresponding payment method.'
    },
    {
        code: 'payment_method_invalid_parameter',
        message: 'Invalid parameter was provided in the payment method object. Check our API documentation or the returned error message for more context'
    },
    {
        code: 'payment_method_microdeposit_failed',
        message: 'Microdeposits were failed to be deposited into the customer’s bank account. Please check the account, institution and transit numbers as well as the currency type.'
    },
    {
        code: 'payment_method_microdeposit_verification_amounts_invalid',
        message: 'You must provide exactly two microdeposit amounts.'
    },
    {
        code: 'payment_method_microdeposit_verification_amounts_mismatch',
        message: 'The amounts provided do not match the amounts that were sent to the bank account.'
    },
    {
        code: 'payment_method_microdeposit_verification_attempts_exceeded',
        message: 'You have exceeded the number of allowed verification attempts.'
    },
    {
        code: 'payment_method_microdeposit_verification_timeout',
        message: 'Payment method should be verified with microdeposits within the required period.'
    },
    {
        code: 'payment_method_provider_decline',
        message: 'The payment was declined by the issuer or customer. Check the last_payment_error property on the PaymentIntent for more details, and provide a new payment method to attempt to fulfill this PaymentIntent again.'
    },
    {
        code: 'payment_method_provider_timeout',
        message: 'The payment method failed due to a timeout. Check the last_payment_error property on the PaymentIntent for more details, and provide a new payment method to attempt to fulfill this PaymentIntent again.'
    },
    {
        code: 'payment_method_unactivated',
        message: 'The operation cannot be performed as the payment method used has not been activated. Activate the payment method in the Dashboard, then try again.'
    },
    {
        code: 'payment_method_unexpected_state',
        message: 'The provided payment method’s state was incompatible with the operation you were trying to perform. Confirm that the payment method is in an allowed state for the given operation before attempting to perform it.'
    },
    {
        code: 'payment_method_unsupported_type',
        message: 'The API only supports payment methods of certain types.'
    },
    {
        code: 'payouts_not_allowed',
        message: 'Payouts have been disabled on the connected account. Check the connected account’s status to see if any additional information needs to be provided, or if payouts have been disabled for another reason.'
    },
    {
        code: 'platform_account_required',
        message: 'Only Stripe Connect platforms can work with other accounts. If you need to setup a Stripe Connect platform, you can do so in the dashboard.'
    },
    {
        code: 'platform_api_key_expired',
        message: 'The API key provided by your Connect platform has expired. This occurs if your platform has either generated a new key or the connected account has been disconnected from the platform. Obtain your current API keys from the Dashboard and update your integration, or reach out to the user and reconnect the account.'
    },
    {
        code: 'postal_code_invalid',
        message: 'The postal code provided was incorrect.'
    },
    {
        code: 'processing_error',
        message: 'An error occurred while processing the card. Try again later or with a different payment method.'
    },
    {
        code: 'product_inactive',
        message: 'The product this SKU belongs to is no longer available for purchase.'
    },
    {
        code: 'rate_limit',
        message: 'Too many requests hit the API too quickly. We recommend an exponential backoff of your requests.'
    },
    {
        code: 'resource_already_exists',
        message: 'A resource with a user-specified ID (e.g., plan or coupon) already exists. Use a different, unique value for id and try again'
    },
    {
        code: 'resource_missing',
        message: 'The ID provided is not valid. Either the resource does not exist, or an ID for a different resource has been provided.'
    },
    {
        code: 'routing_number_invalid',
        message: 'The bank routing number provided is invalid.'
    },
    {
        code: 'secret_key_required',
        message: 'The API key provided is a publishable key, but a secret key is required. Obtain your current API keys from the Dashboard and update your integration to use them'
    },
    {
        code: 'sepa_unsupported_account',
        message: 'Your account does not support SEPA payments.'
    },
    {
        code: 'setup_attempt_failed',
        message: 'The latest setup attempt for the SetupIntent has failed. Check the last_setup_error property on the SetupIntent for more details, and provide a new payment method to attempt to set it up again.'
    },
    {
        code: 'setup_intent_authentication_failure',
        message: 'The provided payment method has failed authentication. Provide a new payment method to attempt to fulfill this SetupIntent again.'
    },
    {
        code: 'setup_intent_invalid_parameter',
        message: 'One or more provided parameters was not allowed for the given operation on the SetupIntent. Check our API reference or the returned error message to see which values were not correct for that SetupIntent.'
    },
    {
        code: 'setup_intent_unexpected_state',
        message: 'The SetupIntent’s state was incompatible with the operation you were trying to perform.'
    },
    {
        code: 'shipping_calculation_failed',
        message: 'Shipping calculation failed as the information provided was either incorrect or could not be verified.'
    },
    {
        code: 'sku_inactive',
        message: 'The SKU is inactive and no longer available for purchase. Use a different SKU, or make the current SKU active again.'
    },
    {
        code: 'state_unsupported',
        message: 'Occurs when providing the legal_entity information for a U.S. custom account, if the provided state is not supported. (This is mostly associated states and territories.)'
    },
    {
        code: 'tax_id_invalid',
        message: 'The tax ID number provided is invalid (e.g., missing digits). Tax ID information varies from country to country, but must be at least nine digits.'
    },
    {
        code: 'taxes_calculation_failed',
        message: 'Tax calculation for the order failed.'
    },
    {
        code: 'terminal_location_country_unsupported',
        message: 'Terminal is currently only available in some countries. Locations in your country cannot be created in livemode.'
    },
    {
        code: 'testmode_charges_only',
        message: 'Your account has not been activated and can only make test charges. Activate your account in the Dashboard to begin processing live charges.'
    },
    {
        code: 'tls_version_unsupported',
        message: 'Your integration is using an older version of TLS that is unsupported. You must be using TLS 1.2 or above.'
    },
    {
        code: 'token_already_used',
        message: 'The token provided has already been used. You must create a new token before you can retry this request.'
    },
    {
        code: 'token_in_use',
        message: 'The token provided is currently being used in another request. This occurs if your integration is making duplicate requests simultaneously.'
    },
    {
        code: 'transfers_not_allowed',
        message: 'The requested transfer cannot be created. Contact us if you are receiving this error.'
    },
    {
        code: 'upstream_order_creation_failed',
        message: 'The order could not be created. Check the order details and then try again.'
    },
    {
        code: 'url_invalid',
        message: 'The URL provided is invalid.'
    }
];